module.exports = __webpack_public_path__ + "img/mg-cnn.3ffa07e9.png";